export default __webpack_public_path__ + "static/media/white_logo.891c6b57.png";